import * as actionTypes from './action-types'

export const getVendorId = id => ({
  type: actionTypes.GET_VENDOR_ID,
  payload: { id },
})

export const getVendorInfo = () => ({
  type: actionTypes.GET_VENDOR_INFO,
})
